import { NextPageWithLayout } from "pages/_app";
import { EmptyLayout } from "client/components/layouts/EmptyLayout";
import { useEffect } from "react";

const IndexPage: NextPageWithLayout = () => {
    useEffect(() => {
        window.location.href = "https://etrainu.com/";
    });

    return null;
};

IndexPage.getLayout = page => <EmptyLayout>{page}</EmptyLayout>;

export default IndexPage;
